import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@01_people/ui-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import SvgIcon from 'components/svg-icon';
import {
  TYPE_ADDRESS,
  TYPE_IDENTITY,
  TYPE_SELFIE,
  TYPE_IDENTITY_OLD,
  TYPE_ADDRESS_OLD
} from 'utils/constants';
import * as ActionCreators from '../../../redux/action';
// import SvgApproved from '../../../assets/svg/icon-approved.svg';
import SvgPending from '../../../assets/svg/icon-pending.svg';
import SvgRejected from '../../../assets/svg/icon-rejected.svg';
import SvgExpired from '../../../assets/svg/icon-expired.svg';
// import { KycPropTypes } from '../../../redux/reducer/types';
import iconIdCard from '../../../assets/svg/id-card-icon.svg';
import successIcon from '../../../assets/svg/circle-success.svg';
import StatusInfoSC from './status-info.styled';

// function ListItem({ document: { reason, status }, name, globalStatus }) {
//   const { t } = useTranslation('pages');

//   function getIdName(short) {
//     switch (short) {
//       case 'driving_license':
//         return t('kyc.documents.drivingLicense');
//       case 'id_card':
//         return t('kyc.documents.idCard');
//       case 'passport':
//         return t('kyc.documents.passport');
//       case 'proof_of_address':
//         return t('kyc.documents.proof_of_address');
//       default:
//         return '';
//     }
//   }

//   if (
//     status === 'approved' ||
//     (status === 'pending' && globalStatus === 'rejected')
//   ) {
//     return null;
//   }
//   return (
//     <li className="status-list-item">
//       <span className="title">{getIdName(name)}</span>
//       {reason && <span> - {reason}</span>}
//     </li>
//   );
// }

// ListItem.propTypes = {
//   document: PropTypes.shape({
//     reason: PropTypes.string.isRequired,
//     status: PropTypes.string.isRequired
//   }).isRequired,
//   name: PropTypes.string.isRequired,
//   globalStatus: PropTypes.string.isRequired
// };

function DocumentStatusInfo({ status, deleteKycDocument, currentDocument }) {
  const { t } = useTranslation('pages');

  const newApplication = useCallback(() => {
    deleteKycDocument(currentDocument.id);
  }, [deleteKycDocument, currentDocument]);

  const iconAndTitle = useMemo(() => {
    if (
      currentDocument.type === TYPE_IDENTITY ||
      TYPE_IDENTITY_OLD.includes(currentDocument.type)
    ) {
      return {
        icon: iconIdCard,
        title: `kyc.${TYPE_IDENTITY}.title`
      };
    }
    if (
      currentDocument.type === TYPE_ADDRESS ||
      currentDocument.type === TYPE_ADDRESS_OLD
    ) {
      return {
        icon: iconIdCard,
        title: `kyc.${TYPE_ADDRESS}.title`
      };
    }
    if (currentDocument.type === TYPE_SELFIE) {
      return {
        icon: iconIdCard,
        title: `kyc.${TYPE_SELFIE}.title`
      };
    }

    return { icon: successIcon, title: `kyc.${TYPE_SELFIE}.title` };
  }, [currentDocument]);

  const {
    text,
    subText,
    icon,
    btnText,
    btnClass,
    btnAction,
    styling
  } = useMemo(() => {
    switch (status) {
      case 'approved':
        return {
          text: t('kyc.status.approved.text'),
          subText: t('kyc.status.approved.subText'),
          btnText: t('kyc.status.approved.btnText'),
          btnClass: '',
          btnAction: newApplication,
          icon: iconAndTitle.icon,
          styling: 'primary'
        };
      case 'pending':
        return {
          text: t('kyc.status.pending.text'),
          subText: t('kyc.status.pending.subText'),
          btnText: t('kyc.status.pending.btnText'),
          btnClass: 'btn-cancel',
          btnAction: newApplication,
          icon: SvgPending,
          styling: 'primary'
        };
      case 'rejectedByAdmin':
        return {
          text: t('kyc.status.rejected.text'),
          subText: t('kyc.status.rejected.subText'),
          btnText: t('kyc.status.rejected.btnText'),
          btnClass: 'btn-cancel',
          btnAction: newApplication,
          icon: SvgRejected,
          styling: 'error'
        };
      case 'expired':
        return {
          text: t('kyc.status.expired.text'),
          subText: t('kyc.status.expired.subText'),
          btnText: t('kyc.status.expired.btnText'),
          btnClass: '',
          btnAction: newApplication,
          icon: SvgExpired,
          styling: 'error'
        };

      default:
        return { text: '', subText: '', icon: null };
    }
  }, [status, iconAndTitle.icon, newApplication, t]);

  return (
    <StatusInfoSC>
      <div className="row justify-space-between">
        <div className="col title-col">
          <div className="row">
            <SvgIcon
              icon={icon}
              alt="identity_icon"
              themed
              active
              styling={styling}
            />
            {status === 'approved' && (
              <img
                className="approved-icon"
                src={successIcon}
                alt="approved_icon"
              />
            )}
            <h5 className="block-title">{t(iconAndTitle.title)}</h5>
          </div>
        </div>
        <div className="btn-wrapper">
          {btnAction && (
            <div className="col title-col">
              <Button
                styling="secondary"
                label={btnText}
                onClick={btnAction}
                customClass={btnClass}
              />
            </div>
          )}
        </div>
      </div>
      <div className="info-text-container">
        <h6>{text}</h6>
        <p className="info-text">{subText}</p>
        {currentDocument.reason ? (
          <p className={status === 'approved' ? 'success-text' : 'error-text'}>
            {currentDocument.reason}
          </p>
        ) : null}
      </div>
      <div className="btn-wrapper-small">
        {btnAction && (
          <div className="col title-col">
            <Button
              styling="secondary"
              label={btnText}
              onClick={btnAction}
              customClass={btnClass}
            />
          </div>
        )}
      </div>
    </StatusInfoSC>
  );
}

DocumentStatusInfo.propTypes = {
  status: PropTypes.string.isRequired,
  currentDocument: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    reason: PropTypes.string
  }),
  deleteKycDocument: PropTypes.func.isRequired
};

DocumentStatusInfo.defaultProps = {
  currentDocument: null
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteKycDocument: ActionCreators.deleteKycDocument
    },
    dispatch
  );
}

export default React.memo(
  connect(
    undefined,
    mapDispatchToProps
  )(DocumentStatusInfo)
);
